module.exports = __webpack_public_path__ + "821ac44.woff2";